export default "tab 3 reports \n"